export default __webpack_public_path__ + "static/media/network.4c2c786b.svg";